@if (zoneIssue) {
  <h2 [innerHTML]="'Something went wrong'"></h2>
  <p>An issue occurred during the setup of your Virtual<br/> Private Server. Please reach out to our<br/>
    Customer Care Team for assistance.</p>

  <div class="db-dialog__buttons-wrap">
    <a class="ds-btn-black" (click)="openIssueChat()"><span>Contact Us</span></a>
  </div>
} @else {
  <h2 [innerHTML]="'Upgrade your VM resources'"></h2>
  <p>To increase your VM parameters, please contact<br/> our <b>Customer Care Team</b> for personalized assistance.</p>

  <div class="db-dialog__buttons-wrap">
    <a class="ds-btn" (click)="close()"><span>{{'text_cancel' | dbText | lowerCaseSpecificWords}}</span></a>
    <a class="ds-btn-black" (click)="openChat()"><span>Contact Us</span></a>
  </div>
}
